import { useEffect } from 'react';
import { Layout, type SidebarItem } from '@omnitok/ui';
import { Copy, FileCode2, GitMerge, History, Languages, LogOut, Store } from 'lucide-react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';

const navigationItems: SidebarItem[] = [
  { id: 'localization', label: 'Localización de Modelos', href: '/localization', icon: <Languages size={18} /> },
  { id: 'sku-consolidation', label: 'Consolidar SKUS', href: '/sku-consolidation', icon: <GitMerge size={18} /> },
  { id: 'batch-templates', label: 'Aplicar templates en lote', href: '/batch-templates', icon: <Copy size={18} /> },
  { id: 'static-models', label: 'Modelos estáticos', href: '/static-models', icon: <FileCode2 size={18} /> },
  {
    id: 'history',
    elementId: 'app-nav-history',
    label: 'Historial de Jobs',
    icon: <History size={18} />,
    badge: 'Próximamente',
  },
  {
    id: 'retailers',
    elementId: 'app-nav-retailers',
    label: 'Mantenedor Retailers',
    icon: <Store size={18} />,
    badge: 'Próximamente',
  },
];

const disabledNavigationElementIds = ['app-nav-history', 'app-nav-retailers'];

const pageTitles: Record<string, string> = {
  '/localization': 'Localización de modelos',
  '/sku-consolidation': 'Consolidar SKUS',
  '/batch-templates': 'Aplicar templates en lote',
  '/static-models': 'Modelos estáticos',
  '/history': 'Historial de Jobs',
  '/retailers': 'Mantenedor Retailers',
  '/translation': 'Nueva Traducción',
};

export default function MainLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const activeId = navigationItems.find((item) => item.href === location.pathname)?.id;

  useEffect(() => {
    disabledNavigationElementIds.forEach((elementId) => {
      const element = document.getElementById(elementId);
      if (element instanceof HTMLButtonElement) {
        element.disabled = true;
        element.setAttribute('aria-disabled', 'true');
      }
    });
  }, []);

  return (
    <Layout
      className="app-shell"
      sidebarItems={navigationItems}
      activeSidebarId={activeId}
      onSidebarItemClick={(item) => {
        if (item.href) navigate(item.href);
      }}
      logo={<span className="app-logo">Omnitok</span>}
      logoCollapsed={<span className="app-logo app-logo--compact">O</span>}
      systemName="Content Translate"
      sidebarFooter={<span className="app-version">v1.0.0</span>}
      headerTitle={pageTitles[location.pathname] ?? 'Omnitok Content'}
      showSearch={false}
      showNotifications={false}
      user={user ? {
        name: user.name || user.email,
        email: user.email,
        role: user.role === 'admin' ? 'Administrador' : 'Usuario',
      } : undefined}
      userMenuItems={[{
        label: 'Cerrar sesión',
        value: 'logout',
        icon: <LogOut size={16} />,
        danger: true,
        dividerBefore: true,
        onClick: () => { void logout(); },
      }]}
    >
      <Outlet />
    </Layout>
  );
}
